import React from 'react';
import { Box, Flex, Text, Button } from '@sparrowengg/twigs-react';
import { ChevronRightIcon } from '@sparrowengg/twigs-react-icons';

const DocumentationBanner = () => {
  return (
    <Box
      css={{
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '$md',
        padding: '$4 $6',
        marginBottom: '$8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '$4'
      }}
    >
      <Flex alignItems="center" gap="$3" css={{ flex: 1 }}>
        <Flex flexDirection="column" gap="$1">
          <Text size="sm" weight="medium" css={{ color: '$neutral700' }}>
            New to AppNest?
          </Text>
          <Text size="sm" css={{ color: '$neutral600', lineHeight: 1.5 }}>
            Don't worry we've got your back, refer the documentation for more
            information
          </Text>
        </Flex>
      </Flex>
      <Button
        variant="ghost"
        color="default"
        size="md"
        rightIcon={<ChevronRightIcon />}
        onClick={() => window.open('/documentation', '_blank')}
        css={{ flexShrink: 0 }}
      >
        Learn More
      </Button>
    </Box>
  );
};

export default DocumentationBanner;
